
// import React, { useState, useEffect } from 'react';
// import { FaMotorcycle } from 'react-icons/fa';
// import { RiMotorbikeFill, RiEBike2Fill, RiEBikeFill } from "react-icons/ri";


// const Filter = () => {
//   const [pickUpDate, setPickUpDate] = useState('');
//   const [dropOffDate, setDropOffDate] = useState('');
//   const [pickUpTime, setPickUpTime] = useState('');
//   const [dropOffTime, setDropOffTime] = useState('');
//   const [rentDuration, setRentDuration] = useState('0 Hours');

//   const [selectedBikes, setSelectedBikes] = useState([]);
//   const [selectedLocations, setSelectedLocations] = useState([]);
//   const [bikeSearch, setBikeSearch] = useState('');
//   const [locationSearch, setLocationSearch] = useState('');

//   const bikeOptions = ['Aprilia RS 457', 'Royal Enfield Guerrilla 450', 'TVS Ntorq 125', 'TVS Jupiter 125 (BS6)'];
//   const locationOptions = ['HSR Layout (4th Sector)', 'Koramangala (Beside Sony Signal)', 'Indiranagar - Metro Station (Near metro station)'];
//   const timeOptions = [
//     "12:00 AM", "12:30 AM", "1:00 AM", "1:30 AM", "2:00 AM", "2:30 AM",
   
//   ];

//   useEffect(() => {
//     if (pickUpDate && dropOffDate && pickUpTime && dropOffTime) {
//       const pickUpDateTime = new Date(`${pickUpDate}T${convertTo24Hour(pickUpTime)}`);
//       const dropOffDateTime = new Date(`${dropOffDate}T${convertTo24Hour(dropOffTime)}`);
//       const durationInMillis = dropOffDateTime - pickUpDateTime;
//       const durationInHours = Math.floor(durationInMillis / (1000 * 60 * 60));
//       const remainingMinutes = Math.round((durationInMillis % (1000 * 60 * 60)) / (1000 * 60));
//       setRentDuration(`${durationInHours} Hours${remainingMinutes > 0 ? ` ${remainingMinutes} Minutes` : ''}`);
//     }
//   }, [pickUpDate, dropOffDate, pickUpTime, dropOffTime]);

//   const convertTo24Hour = (time) => {
//     const [timePart, modifier] = time.split(' ');
//     let [hours, minutes] = timePart.split(':').map(Number);
//     if (modifier === 'PM' && hours < 12) hours += 12;
//     if (modifier === 'AM' && hours === 12) hours = 0;
//     return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
//   };

//   // Toggle bike selection
//   const handleBikeSelect = (bike) => {
//     if (selectedBikes.includes(bike)) {
//       setSelectedBikes(selectedBikes.filter((b) => b !== bike));
//     } else {
//       setSelectedBikes([...selectedBikes, bike]);
//     }
//   };

//   // Remove individual bike
//   const removeBike = (bike) => {
//     setSelectedBikes(selectedBikes.filter((b) => b !== bike));
//   };

//   // Toggle location selection
//   const handleLocationSelect = (location) => {
//     if (selectedLocations.includes(location)) {
//       setSelectedLocations(selectedLocations.filter((loc) => loc !== location));
//     } else {
//       setSelectedLocations([...selectedLocations, location]);
//     }
//   };

//   // Remove individual location
//   const removeLocation = (location) => {
//     setSelectedLocations(selectedLocations.filter((loc) => loc !== location));
//   };

//   const clearBikeFilter = () => {
//     setSelectedBikes([]);
//   };

//   const clearLocationFilter = () => {
//     setSelectedLocations([]);
//   };

//   // Filter options based on search input
//   const filteredBikes = bikeOptions.filter(bike => bike.toLowerCase().includes(bikeSearch.toLowerCase()));
//   const filteredLocations = locationOptions.filter(location => location.toLowerCase().includes(locationSearch.toLowerCase()));

//   return (
//     <div className="w-full bg-white shadow-lg rounded-lg p-6 ml-32  mt-12">
//       Filter
//       {/* Date and Time Section */}
//       <div className="mb-6">
//         <h2 className="text-lg font-semibold mb-4">Select Date & Time</h2>
//         <div className="grid grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium mb-1">Pick-up date</label>
//             <input
//               type="date"
//               value={pickUpDate}
//               onChange={(e) => setPickUpDate(e.target.value)}
//               className="mt-1 block w-full  border border-gray-300  rounded-md shadow-sm py-2 cursor-pointer"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium mb-1">Pick-up time</label>
//             <select
//               value={pickUpTime}
//               onChange={(e) => setPickUpTime(e.target.value)}
//               className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2"
//             >
//               {timeOptions.map(time => (
//                 <option key={time} value={time}>{time}</option>
//               ))}
//             </select>
//           </div>
//         </div>

//         <div className="grid grid-cols-2 gap-4 mt-4">
//           <div>
//             <label className="block text-sm font-medium mb-1">Drop-off date</label>
//             <input
//               type="date"
//               value={dropOffDate}
//               onChange={(e) => setDropOffDate(e.target.value)}
//               className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 cursor-pointer"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium mb-1">Drop-off time</label>
//             <select
//               value={dropOffTime}
//               onChange={(e) => setDropOffTime(e.target.value)}
//               className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2"
//             >
//               {timeOptions.map(time => (
//                 <option key={time} value={time}>{time}</option>
//               ))}
//             </select>
//           </div>
//         </div>

//         <div className="mt-4"> 
//           <label className="block text-sm  font-medium">Rent Duration</label>
//           <input
//             type="text"
//             value={rentDuration}
//             readOnly
//             className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2"
//           />
//         </div>
//       </div>

//       {/* Categories Section */}
//       <div className="mb-6">
//         <h2 className="text-lg font-semibold mb-4">Categories</h2>
//         <div className="grid grid-cols-2 gap-4">
//           <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//             <RiEBike2Fill className="mb-2 text-5xl" />
//             Scooter
//           </button>
//           <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//             <RiMotorbikeFill className="mb-2 text-5xl" />
//             Sports
//           </button>
//           <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//             <FaMotorcycle className="mb-2 text-5xl" />
//             Cruiser
//           </button>
//           <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//             <RiEBikeFill className="mb-2 text-5xl" />
//             Go-Electric
//           </button>
//         </div>
//       </div>
//       <div className="max-w-md mx-auto p-4">
//         {/* Search by bike model */}
//         <div className="mb-6">
//           <div className="flex justify-between items-center mb-2">
//             <label className="text-gray-700 font-medium">Search by bike model</label>
//             <button onClick={clearBikeFilter} className="text-sm bg-gray-300 text-gray-500 rounded-xl">Clear ✕</button>
//           </div>
//           <div className="flex mb-2 items-center bg-gray-100 p-2 rounded">
//             {selectedBikes.length > 0 && (
//               <div className="flex flex-wrap">
//                 {selectedBikes.map((bike, index) => (
//                   <span key={index} className="mr-2 mb-1 bg-gray-200 px-2 py-1 rounded flex items-center space-x-1">
//                     {bike}
//                     <button onClick={() => removeBike(bike)} className="text-red-500 font-bold">✕</button>
//                   </span>
//                 ))}
//               </div>
//             )}
//             <input
//               type="text"
//               placeholder="Search bike models"
//               className="bg-transparent flex-1 outline-none"
//               value={bikeSearch}
//               onChange={(e) => setBikeSearch(e.target.value)}
//             />
//             <button className="ml-2">
//               <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
//               </svg>
//             </button>
//           </div>
//           <div className="bg-white border rounded max-h-32 overflow-y-auto">
//             {filteredBikes.map((bike, index) => (
//               <div key={index} className="flex items-center px-4 py-2">
//                 <input
//                   type="checkbox"
//                   checked={selectedBikes.includes(bike)}
//                   onChange={() => handleBikeSelect(bike)}
//                   className="mr-2"
//                 />
//                 <label>{bike}</label>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Search by location */}
//         <div className="mb-6">
//           <div className="flex justify-between items-center mb-2">
//             <label className="text-gray-700 font-medium">Search by location</label>
//             <button onClick={clearLocationFilter} className="text-sm bg-gray-300 text-gray-500 rounded-xl">Clear ✕</button>
//           </div>
//           <div className="flex mb-2 items-center bg-gray-100 p-2 rounded">
//             {selectedLocations.length > 0 && (
//               <div className="flex flex-wrap">
//                 {selectedLocations.map((location, index) => (
//                   <span key={index} className="mr-2 mb-1 bg-gray-200 px-2 py-1 rounded flex items-center space-x-1">
//                     {location}
//                     <button onClick={() => removeLocation(location)} className="text-red-500 font-bold">✕</button>
//                   </span>
//                 ))}
//               </div>
//             )}
//             <input
//               type="text"
//               placeholder="Search locations"
//               className="bg-transparent flex-1 outline-none"
//               value={locationSearch}
//               onChange={(e) => setLocationSearch(e.target.value)}
//             />
//             <button className="ml-2">
//               <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
//               </svg>
//             </button>
//           </div>
//           <div className="bg-white border rounded max-h-32 overflow-y-auto">
//             {filteredLocations.map((location, index) => (
//               <div key={index} className="flex items-center px-4 py-2">
//                 <input
//                   type="checkbox"
//                   checked={selectedLocations.includes(location)}
//                   onChange={() => handleLocationSelect(location)}
//                   className="mr-2"
//                 />
//                 <label>{location}</label>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Apply Filter Button */}
//         <button className="w-full bg- [#C06C3D] text-white py-2 rounded bg-[#C06C3D]">
//           Apply Filter
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Filter;



// import React, { useState, useEffect } from 'react';
// import { FaMotorcycle } from 'react-icons/fa';
// import { RiMotorbikeFill, RiEBike2Fill, RiEBikeFill } from "react-icons/ri";


// const Filter = () => {
//   const [pickUpDate, setPickUpDate] = useState('');
//   const [dropOffDate, setDropOffDate] = useState('');
//   const [pickUpTime, setPickUpTime] = useState('');
//   const [dropOffTime, setDropOffTime] = useState('');
//   const [rentDuration, setRentDuration] = useState('0 Hours');

//   const [selectedBikes, setSelectedBikes] = useState([]);
//   const [selectedLocations, setSelectedLocations] = useState([]);
//   const [bikeSearch, setBikeSearch] = useState('');
//   const [locationSearch, setLocationSearch] = useState('');

//   const bikeOptions = ['Aprilia RS 457', 'Royal Enfield Guerrilla 450', 'TVS Ntorq 125', 'TVS Jupiter 125 (BS6)'];
//   const locationOptions = ['HSR Layout (4th Sector)', 'Koramangala (Beside Sony Signal)', 'Indiranagar - Metro Station (Near metro station)'];
 
//   const timeOptions = [
//     "Select time", "12:00 AM", "12:30 AM", "1:00 AM", "1:30 AM", "2:00 AM", "2:30 AM", 
//     "3:00 AM", "3:30 AM", "4:00 AM", "4:30 AM", "5:00 AM", "5:30 AM", // add more times as needed
//   ];

//   useEffect(() => {
//     if (
//       pickUpDate &&
//       dropOffDate &&
//       pickUpTime !== "Select time" &&
//       dropOffTime !== "Select time" &&
//       pickUpTime &&
//       dropOffTime
//     ) {
//       const pickUpDateTime = new Date(`${pickUpDate}T${convertTo24Hour(pickUpTime)}`);
//       const dropOffDateTime = new Date(`${dropOffDate}T${convertTo24Hour(dropOffTime)}`);
  
//       if (pickUpDateTime <= dropOffDateTime) {
//         const durationInMillis = dropOffDateTime - pickUpDateTime;
//         const durationInHours = Math.floor(durationInMillis / (1000 * 60 * 60));
//         const remainingMinutes = Math.round((durationInMillis % (1000 * 60 * 60)) / (1000 * 60));
//         setRentDuration(`${durationInHours} Hours${remainingMinutes > 0 ? ` ${remainingMinutes} Minutes` : ''}`);
//       } else {
//         setRentDuration("Invalid selection: drop-off must be after pick-up");
//       }
//     }
//   }, [pickUpDate, dropOffDate, pickUpTime, dropOffTime]);
  
//   const convertTo24Hour = (time) => {
//     if (!time) return "00:00:00";  // Default or fallback value if `time` is undefined
//     const [timePart, modifier] = time.split(' ');
//     let [hours, minutes] = timePart.split(':').map(Number);
//     if (modifier === 'PM' && hours < 12) hours += 12;
//     if (modifier === 'AM' && hours === 12) hours = 0;
//     return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
//   };
  
//   // Toggle bike selection
//   const handleBikeSelect = (bike) => {
//     if (selectedBikes.includes(bike)) {
//       setSelectedBikes(selectedBikes.filter((b) => b !== bike));
//     } else {
//       setSelectedBikes([...selectedBikes, bike]);
//     }
//   };

//   // Remove individual bike
//   const removeBike = (bike) => {
//     setSelectedBikes(selectedBikes.filter((b) => b !== bike));
//   };

//   // Toggle location selection
//   const handleLocationSelect = (location) => {
//     if (selectedLocations.includes(location)) {
//       setSelectedLocations(selectedLocations.filter((loc) => loc !== location));
//     } else {
//       setSelectedLocations([...selectedLocations, location]);
//     }
//   };

//   // Remove individual location
//   const removeLocation = (location) => {
//     setSelectedLocations(selectedLocations.filter((loc) => loc !== location));
//   };

//   const clearBikeFilter = () => {
//     setSelectedBikes([]);
//   };

//   const clearLocationFilter = () => {
//     setSelectedLocations([]);
//   };

//   // Filter options based on search input
//   const filteredBikes = bikeOptions.filter(bike => bike.toLowerCase().includes(bikeSearch.toLowerCase()));
//   const filteredLocations = locationOptions.filter(location => location.toLowerCase().includes(locationSearch.toLowerCase()));

//   return (
//     <>
//     <h1 className="text-2xl font-bold mb-6">Filter</h1>
//     <div className="w-full bg-white shadow-lg rounded-lg p-6 ml-32  mt-12">
    
//       {/* Date and Time Section */}
//       <div className="mb-6">
//         <h2 className="text-lg font-semibold mb-4">Select Date & Time</h2>
//         <div className="grid grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium mb-1">Pick-up date</label>
//             <input
//               type="date"
//               value={pickUpDate}
//               onChange={(e) => setPickUpDate(e.target.value)}
//               className="mt-1 block w-full  border border-gray-300  rounded-md shadow-sm py-2 cursor-pointer"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium mb-1">Pick-up time</label>
//             <select
//               value={pickUpTime}
//               onChange={(e) => setPickUpTime(e.target.value)}
//               className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 cursor-pointer"
//             >
//                {timeOptions.map((time) => (
//               <option key={time} value={time}>
//                 {time}
//               </option>
//             ))}
//             </select>
//           </div>
//         </div>

//         <div className="grid grid-cols-2 gap-4 mt-4">
//           <div>
//             <label className="block text-sm font-medium mb-1">Drop-off date</label>
//             <input
//               type="date"
//               value={dropOffDate}
//               onChange={(e) => setDropOffDate(e.target.value)}
//               className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 cursor-pointer"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium mb-1">Drop-off time</label>
//             <select
//               value={dropOffTime}
//               onChange={(e) => setDropOffTime(e.target.value)}
//               className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 cursor-pointer"
//             >
//               {timeOptions.map((time) => (
//               <option key={time} value={time}>
//                 {time}
//               </option>
//             ))}
//             </select>
//           </div>
//         </div>

//         <div className="mt-4"> 
//           <label className="block text-sm  font-medium">Rent Duration</label>
//           <input
//           type="text"
//           value={rentDuration}
//           readOnly
//           className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2"
//         />
//         </div>
//       </div>

//       {/* Categories Section */}
//       <div className="mb-6">
//         <h2 className="text-lg font-semibold mb-4">Categories</h2>
//         <div className="grid grid-cols-2 gap-4">
//           <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//             <RiEBike2Fill className="mb-2 text-5xl" />
//             Scooter
//           </button>
//           <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//             <RiMotorbikeFill className="mb-2 text-5xl" />
//             Sports
//           </button>
//           <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//             <FaMotorcycle className="mb-2 text-5xl" />
//             Cruiser
//           </button>
//           <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//             <RiEBikeFill className="mb-2 text-5xl" />
//             Go-Electric
//           </button>
//         </div>
//       </div>
//       <div className="max-w-md mx-auto p-4">
//         {/* Search by bike model */}
//         <div className="mb-6">
//           <div className="flex justify-between items-center mb-2">
//             <label className="text-gray-700 font-medium">Search by bike model</label>
//             <button onClick={clearBikeFilter} className="text-sm bg-gray-300 text-gray-500 rounded-xl">Clear ✕</button>
//           </div>
//           <div className="flex mb-2 items-center bg-gray-100 p-2 rounded">
//             {selectedBikes.length > 0 && (
//               <div className="flex flex-wrap">
//                 {selectedBikes.map((bike, index) => (
//                   <span key={index} className="mr-2 mb-1 bg-gray-200 px-2 py-1 rounded flex items-center space-x-1">
//                     {bike}
//                     <button onClick={() => removeBike(bike)} className="text-red-500 font-bold">✕</button>
//                   </span>
//                 ))}
//               </div>
//             )}
//             <input
//               type="text"
//               placeholder="Search bike models"
//               className="bg-transparent flex-1 outline-none"
//               value={bikeSearch}
//               onChange={(e) => setBikeSearch(e.target.value)}
//             />
//             <button className="ml-2">
//               <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
//               </svg>
//             </button>
//           </div>
//           <div className="bg-white border rounded max-h-32 overflow-y-auto">
//             {filteredBikes.map((bike, index) => (
//               <div key={index} className="flex items-center px-4 py-2">
//                 <input
//                   type="checkbox"
//                   checked={selectedBikes.includes(bike)}
//                   onChange={() => handleBikeSelect(bike)}
//                   className="mr-2"
//                 />
//                 <label>{bike}</label>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Search by location */}
//         <div className="mb-6">
//           <div className="flex justify-between items-center mb-2">
//             <label className="text-gray-700 font-medium">Search by location</label>
//             <button onClick={clearLocationFilter} className="text-sm bg-gray-300 text-gray-500 rounded-xl">Clear ✕</button>
//           </div>
//           <div className="flex mb-2 items-center bg-gray-100 p-2 rounded">
//             {selectedLocations.length > 0 && (
//               <div className="flex flex-wrap">
//                 {selectedLocations.map((location, index) => (
//                   <span key={index} className="mr-2 mb-1 bg-gray-200 px-2 py-1 rounded flex items-center space-x-1">
//                     {location}
//                     <button onClick={() => removeLocation(location)} className="text-red-500 font-bold">✕</button>
//                   </span>
//                 ))}
//               </div>
//             )}
//             <input
//               type="text"
//               placeholder="Search locations"
//               className="bg-transparent flex-1 outline-none"
//               value={locationSearch}
//               onChange={(e) => setLocationSearch(e.target.value)}
//             />
//             <button className="ml-2">
//               <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
//               </svg>
//             </button>
//           </div>
//           <div className="bg-white border rounded max-h-32 overflow-y-auto">
//             {filteredLocations.map((location, index) => (
//               <div key={index} className="flex items-center px-4 py-2">
//                 <input
//                   type="checkbox"
//                   checked={selectedLocations.includes(location)}
//                   onChange={() => handleLocationSelect(location)}
//                   className="mr-2"
//                 />
//                 <label>{location}</label>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Apply Filter Button */}
//         <button className="w-full bg- [#C06C3D] text-white py-2 rounded bg-[#C06C3D]">
//           Apply Filter
//         </button>
//       </div>
//     </div>
//     </>
//   );
// };

// export default Filter;




// import React, { useState, useEffect } from 'react';
// import { FaMotorcycle } from 'react-icons/fa';
// import { RiMotorbikeFill, RiEBike2Fill, RiEBikeFill } from "react-icons/ri";

// const Filter = () => {
//   const [pickUpDate, setPickUpDate] = useState('');
//   const [dropOffDate, setDropOffDate] = useState('');
//   const [pickUpTime, setPickUpTime] = useState('');
//   const [dropOffTime, setDropOffTime] = useState('');
//   const [rentDuration, setRentDuration] = useState('0 Hours');

//   const [selectedBikes, setSelectedBikes] = useState([]);
//   const [selectedLocations, setSelectedLocations] = useState([]);
//   const [bikeSearch, setBikeSearch] = useState('');
//   const [locationSearch, setLocationSearch] = useState('');

//   const bikeOptions = ['Aprilia RS 457', 'Royal Enfield Guerrilla 450', 'TVS Ntorq 125', 'TVS Jupiter 125 (BS6)'];
//   const locationOptions = ['HSR Layout (4th Sector)', 'Koramangala (Beside Sony Signal)', 'Indiranagar - Metro Station (Near metro station)'];
 
//   const timeOptions = [
//     "Select time", "12:00 AM", "12:30 AM", "1:00 AM", "1:30 AM", "2:00 AM", "2:30 AM", 
//     "3:00 AM", "3:30 AM", "4:00 AM", "4:30 AM", "5:00 AM", "5:30 AM", // add more times as needed
//   ];

//   useEffect(() => {
//     if (
//       pickUpDate &&
//       dropOffDate &&
//       pickUpTime !== "Select time" &&
//       dropOffTime !== "Select time" &&
//       pickUpTime &&
//       dropOffTime
//     ) {
//       const pickUpDateTime = new Date(`${pickUpDate}T${convertTo24Hour(pickUpTime)}`);
//       const dropOffDateTime = new Date(`${dropOffDate}T${convertTo24Hour(dropOffTime)}`);
  
//       if (pickUpDateTime <= dropOffDateTime) {
//         const durationInMillis = dropOffDateTime - pickUpDateTime;
//         const durationInHours = Math.floor(durationInMillis / (1000 * 60 * 60));
//         const remainingMinutes = Math.round((durationInMillis % (1000 * 60 * 60)) / (1000 * 60));
//         setRentDuration(`${durationInHours} Hours${remainingMinutes > 0 ? ` ${remainingMinutes} Minutes` : ''}`);
//       } else {
//         setRentDuration("Invalid selection: drop-off must be after pick-up");
//       }
//     }
//   }, [pickUpDate, dropOffDate, pickUpTime, dropOffTime]);
  
//   const convertTo24Hour = (time) => {
//     if (!time) return "00:00:00";  // Default or fallback value if `time` is undefined
//     const [timePart, modifier] = time.split(' ');
//     let [hours, minutes] = timePart.split(':').map(Number);
//     if (modifier === 'PM' && hours < 12) hours += 12;
//     if (modifier === 'AM' && hours === 12) hours = 0;
//     return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
//   };
  
//   // Toggle bike selection
//   const handleBikeSelect = (bike) => {
//     if (selectedBikes.includes(bike)) {
//       setSelectedBikes(selectedBikes.filter((b) => b !== bike));
//     } else {
//       setSelectedBikes([...selectedBikes, bike]);
//     }
//   };

//   // Remove individual bike
//   const removeBike = (bike) => {
//     setSelectedBikes(selectedBikes.filter((b) => b !== bike));
//   };

//   // Toggle location selection
//   const handleLocationSelect = (location) => {
//     if (selectedLocations.includes(location)) {
//       setSelectedLocations(selectedLocations.filter((loc) => loc !== location));
//     } else {
//       setSelectedLocations([...selectedLocations, location]);
//     }
//   };

//   // Remove individual location
//   const removeLocation = (location) => {
//     setSelectedLocations(selectedLocations.filter((loc) => loc !== location));
//   };

//   const clearBikeFilter = () => {
//     setSelectedBikes([]);
//   };

//   const clearLocationFilter = () => {
//     setSelectedLocations([]);
//   };

//   // Filter options based on search input
//   const filteredBikes = bikeOptions.filter(bike => bike.toLowerCase().includes(bikeSearch.toLowerCase()));
//   const filteredLocations = locationOptions.filter(location => location.toLowerCase().includes(locationSearch.toLowerCase()));

//   return (
//     <>
//        <h1 className="text-2xl font-bold mb-6">Filter</h1>
//     <div className="w-full bg-white shadow-lg rounded-lg p-6 ">
//       {/* Date and Time Section */}
//       <div className="mb-6">
//         <h2 className="text-lg font-semibold mb-4 text-left">Select Date & Time</h2>
//         <div className="grid grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium mb-1">Pick-up date</label>
//             <input
//               type="date"
//               value={pickUpDate}
//               onChange={(e) => setPickUpDate(e.target.value)}
//               className="mt-1 block w-full  border border-gray-300  rounded-md shadow-sm py-2 cursor-pointer"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium mb-1">Pick-up time</label>
//             <select
//               value={pickUpTime}
//               onChange={(e) => setPickUpTime(e.target.value)}
//               className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 cursor-pointer"
//             >
//                {timeOptions.map((time) => (
//               <option key={time} value={time}>
//                 {time}
//               </option>
//             ))}
//             </select>
//           </div>
//         </div>

//         <div className="grid grid-cols-2 gap-4 mt-4">
//           <div>
//             <label className="block text-sm font-medium mb-1">Drop-off date</label>
//             <input
//               type="date"
//               value={dropOffDate}
//               onChange={(e) => setDropOffDate(e.target.value)}
//               className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 cursor-pointer"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium mb-1">Drop-off time</label>
//             <select
//               value={dropOffTime}
//               onChange={(e) => setDropOffTime(e.target.value)}
//               className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 cursor-pointer"
//             >
//               {timeOptions.map((time) => (
//               <option key={time} value={time}>
//                 {time}
//               </option>
//             ))}
//             </select>
//           </div>
//         </div>

//         <div className="mt-4"> 
//           <label className="block text-sm  font-medium">Rent Duration</label>
//           <input
//           type="text"
//           value={rentDuration}
//           readOnly
//           className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2"
//         />
//         </div>
//       </div>

//       {/* Categories Section */}
//       <div className="mb-6">
//         <h2 className="text-lg font-semibold mb-4">Categories</h2>
//         <div className="grid grid-cols-2 gap-4">
//           <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//             <RiEBike2Fill className="mb-2 text-5xl" />
//             Scooter
//           </button>
//           <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//             <RiMotorbikeFill className="mb-2 text-5xl" />
//             Sports
//           </button>
//           <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//             <FaMotorcycle className="mb-2 text-5xl" />
//             Cruiser
//           </button>
//           <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
//             <RiEBikeFill className="mb-2 text-5xl" />
//             Go-Electric
//           </button>
//         </div>
//       </div>
//       <div className="max-w-md mx-auto p-4">
       
//          <div className="max-w-md mx-auto">
//           {/* Search by bike model */}
//           <div className="mb-6">
//             <div className="flex justify-between items-center mb-2">
//               <label className="text-gray-700 font-medium">Search by bike model</label>
//               <button onClick={clearBikeFilter} className="px-3 py-1 bg-gray-300 text-gray-500 rounded-3xl">Clear ✕</button>
//             </div>
//             <div className="flex mb-2 items-center bg-gray-100 p-2 rounded flex-wrap">
//               {selectedBikes.map((bike, index) => (
//                 <span key={index} className="mr-2 mb-2 bg-gray-200 px-2 py-1 rounded-3xl flex items-center">
//                   {bike}
//                   <button onClick={() => removeBike(bike)} className="text-red-500 ml-1">✕</button>
//                 </span>
//               ))}
//               <input
//                 type="text"
//                 placeholder="Search bike models"
//                 className="bg-transparent flex-1 outline-none"
//                 value={bikeSearch}
//                 onChange={(e) => setBikeSearch(e.target.value)}
//               />
//             </div>
//             <div className="bg-white border rounded max-h-32 overflow-y-auto">
//               {filteredBikes.map((bike, index) => (
//                 <div key={index} className="flex items-center px-4 py-2">
//                   <input
//                     type="checkbox"
//                     checked={selectedBikes.includes(bike)}
//                     onChange={() => handleBikeSelect(bike)}
//                     className="mr-2"
//                   />
//                   <label>{bike}</label>
//                 </div>
//               ))}
//             </div>
//           </div>


   
       
//          {/* Search by location */}
//          <div className="mb-6">
//             <div className="flex justify-between items-center mb-2">
//               <label className="text-gray-700 font-medium">Search by location</label>
//               <button onClick={clearLocationFilter} className="px-3 py-1 bg-gray-300 text-gray-500 rounded-3xl">Clear ✕</button>
//             </div>
//             <div className="flex mb-2 items-center bg-gray-100 p-2 rounded flex-wrap">
//               {selectedLocations.map((location, index) => (
//                 <span key={index} className="mr-2 mb-2 bg-gray-200 px-2 py-1 rounded-3xl flex items-center">
//                   {location}
//                   <button onClick={() => removeLocation(location)} className="text-red-500 ml-1 ">✕</button>
//                 </span>
//               ))}
//               <input
//                 type="text"
//                 placeholder="Search locations"
//                 className="bg-transparent flex-1 outline-none"
//                 value={locationSearch}
//                 onChange={(e) => setLocationSearch(e.target.value)}
//               />
//             </div>
//             <div className="bg-white border rounded max-h-32 overflow-y-auto">
//               {filteredLocations.map((location, index) => (
//                 <div key={index} className="flex items-center px-4 py-2">
//                   <input
//                     type="checkbox"
//                     checked={selectedLocations.includes(location)}
//                     onChange={() => handleLocationSelect(location)}
//                     className="mr-2"
//                   />
//                   <label>{location}</label>
//                 </div>
//               ))}
//             </div>
//           </div>

//         {/* Apply Filter Button */}
//         <button className="w-full bg- [#C06C3D] text-white py-2 rounded bg-[#C06C3D]">
//           Apply Filter
//         </button>
//       </div>
//     </div>
//     </div>
//     </>
//   );
// };

// export default Filter;


import React, { useState, useEffect } from 'react';
import { FaMotorcycle } from 'react-icons/fa';
import { RiMotorbikeFill, RiEBike2Fill, RiEBikeFill } from "react-icons/ri";

const Filter = () => {
  const [pickUpDate, setPickUpDate] = useState('');
  const [dropOffDate, setDropOffDate] = useState('');
  const [pickUpTime, setPickUpTime] = useState('');
  const [dropOffTime, setDropOffTime] = useState('');
  const [rentDuration, setRentDuration] = useState('0 Hours');

  const [selectedBikes, setSelectedBikes] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [bikeSearch, setBikeSearch] = useState('');
  const [locationSearch, setLocationSearch] = useState('');

  const bikeOptions = ['Aprilia RS 457', 'Royal Enfield Guerrilla 450', 'TVS Ntorq 125', 'TVS Jupiter 125 (BS6)'];
  const locationOptions = ['HSR Layout (4th Sector)', 'Koramangala (Beside Sony Signal)', 'Indiranagar - Metro Station (Near metro station)'];
 
  const timeOptions = [
    "Select time", "12:00 AM", "12:30 AM", "1:00 AM", "1:30 AM", "2:00 AM", "2:30 AM", 
    "3:00 AM", "3:30 AM", "4:00 AM", "4:30 AM", "5:00 AM", "5:30 AM", // add more times as needed
  ];

  useEffect(() => {
    if (
      pickUpDate &&
      dropOffDate &&
      pickUpTime !== "Select time" &&
      dropOffTime !== "Select time" &&
      pickUpTime &&
      dropOffTime
    ) {
      const pickUpDateTime = new Date(`${pickUpDate}T${convertTo24Hour(pickUpTime)}`);
      const dropOffDateTime = new Date(`${dropOffDate}T${convertTo24Hour(dropOffTime)}`);
  
      if (pickUpDateTime <= dropOffDateTime) {
        const durationInMillis = dropOffDateTime - pickUpDateTime;
        const durationInHours = Math.floor(durationInMillis / (1000 * 60 * 60));
        const remainingMinutes = Math.round((durationInMillis % (1000 * 60 * 60)) / (1000 * 60));
        setRentDuration(`${durationInHours} Hours${remainingMinutes > 0 ? ` ${remainingMinutes} Minutes` : ''}`);
      } else {
        setRentDuration("Invalid selection: drop-off must be after pick-up");
      }
    }
  }, [pickUpDate, dropOffDate, pickUpTime, dropOffTime]);
  
  const convertTo24Hour = (time) => {
    if (!time) return "00:00:00";  // Default or fallback value if `time` is undefined
    const [timePart, modifier] = time.split(' ');
    let [hours, minutes] = timePart.split(':').map(Number);
    if (modifier === 'PM' && hours < 12) hours += 12;
    if (modifier === 'AM' && hours === 12) hours = 0;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
  };
  
  // Toggle bike selection
  const handleBikeSelect = (bike) => {
    if (selectedBikes.includes(bike)) {
      setSelectedBikes(selectedBikes.filter((b) => b !== bike));
    } else {
      setSelectedBikes([...selectedBikes, bike]);
    }
  };

  // Remove individual bike
  const removeBike = (bike) => {
    setSelectedBikes(selectedBikes.filter((b) => b !== bike));
  };

  // Toggle location selection
  const handleLocationSelect = (location) => {
    if (selectedLocations.includes(location)) {
      setSelectedLocations(selectedLocations.filter((loc) => loc !== location));
    } else {
      setSelectedLocations([...selectedLocations, location]);
    }
  };

  // Remove individual location
  const removeLocation = (location) => {
    setSelectedLocations(selectedLocations.filter((loc) => loc !== location));
  };

  const clearBikeFilter = () => {
    setSelectedBikes([]);
  };

  const clearLocationFilter = () => {
    setSelectedLocations([]);
  };

  // Filter options based on search input
  const filteredBikes = bikeOptions.filter(bike => bike.toLowerCase().includes(bikeSearch.toLowerCase()));
  const filteredLocations = locationOptions.filter(location => location.toLowerCase().includes(locationSearch.toLowerCase()));

  return (
    <>
       <h1 className="text-xl font-semibold mb-3">Filter</h1>
    <div className="w-full bg-white shadow-lg rounded-lg p-6 ">
      {/* Date and Time Section */}
      <div className="mb-6">
        <h2 className="text-lg font-semibold mb-4 text-left">Select Date & Time</h2>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Pick-up date</label>
            <input
              type="date"
              value={pickUpDate}
              onChange={(e) => setPickUpDate(e.target.value)}
              className="mt-1 block w-full  border border-gray-300  rounded-md shadow-sm py-2 cursor-pointer"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Pick-up time</label>
            <select
              value={pickUpTime}
              onChange={(e) => setPickUpTime(e.target.value)}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 cursor-pointer"
            >
               {timeOptions.map((time) => (
              <option key={time} value={time}>
                {time}
              </option>
            ))}
            </select>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 mt-4">
          <div>
            <label className="block text-sm font-medium mb-1">Drop-off date</label>
            <input
              type="date"
              value={dropOffDate}
              onChange={(e) => setDropOffDate(e.target.value)}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 cursor-pointer"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Drop-off time</label>
            <select
              value={dropOffTime}
              onChange={(e) => setDropOffTime(e.target.value)}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 cursor-pointer"
            >
              {timeOptions.map((time) => (
              <option key={time} value={time}>
                {time}
              </option>
            ))}
            </select>
          </div>
        </div>

        <div className="mt-4"> 
          <label className="block text-sm  font-medium">Rent Duration</label>
          <input
          type="text"
          value={rentDuration}
          readOnly
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2"
        />
        </div>
      </div>

      {/* Categories Section */}
      <div className="mb-6">
        <h2 className="text-lg font-semibold mb-4">Categories</h2>
        <div className="grid grid-cols-2 gap-4">
          <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
            <RiEBike2Fill className="mb-2 text-5xl" />
            Scooter
          </button>
          <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
            <RiMotorbikeFill className="mb-2 text-5xl" />
            Sports
          </button>
          <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
            <FaMotorcycle className="mb-2 text-5xl" />
            Cruiser
          </button>
          <button className="flex flex-col items-center justify-center p-3 border border-gray-300 rounded-md text-center">
            <RiEBikeFill className="mb-2 text-5xl" />
            Go-Electric
          </button>
        </div>
      </div>
      <div className="max-w-md mx-auto p-4">
       
         <div className="max-w-md mx-auto">
          {/* Search by bike model */}
          <div className="mb-6">
            <div className="flex justify-between items-center mb-2">
              <label className="text-gray-700 font-medium">Search by bike model</label>
              <button onClick={clearBikeFilter} className="px-3 py-1 bg-gray-300 text-gray-500 rounded-3xl">Clear ✕</button>
            </div>
            <div className="flex mb-2 items-center bg-gray-100 p-2 rounded flex-wrap border">
              {selectedBikes.map((bike, index) => (
                <span key={index} className="mr-2 mb-2 bg-gray-200 px-2 py-1 rounded-3xl flex items-center">
                  {bike}
                  <button onClick={() => removeBike(bike)} className="text-red-500 ml-1">✕</button>
                </span>
              ))}
              <input
                type="text"
                placeholder="Search bike models"
                className="bg-transparent flex-1 outline-none "
                value={bikeSearch}
                onChange={(e) => setBikeSearch(e.target.value)}
              />
            </div>
            <div className="bg-white border rounded max-h-32 overflow-y-auto">
              {filteredBikes.map((bike, index) => (
                <div key={index} className="flex items-center px-4 py-2">
                  <input
                    type="checkbox"
                    checked={selectedBikes.includes(bike)}
                    onChange={() => handleBikeSelect(bike)}
                    className="mr-2"
                  />
                  <label>{bike}</label>
                </div>
              ))}
            </div>
          </div>


   
       
         {/* Search by location */}
         <div className="mb-6">
            <div className="flex justify-between items-center mb-2 ">
              <label className="text-gray-700 font-medium">Search by location</label>
              <button onClick={clearLocationFilter} className="px-3 py-1 bg-gray-300 text-gray-500 rounded-3xl">Clear ✕</button>
            </div>
            <div className="flex mb-2 items-center bg-gray-100 p-2 rounded flex-wrap border">
              {selectedLocations.map((location, index) => (
                <span key={index} className="mr-2 mb-2 bg-gray-200 px-2 py-1 rounded-3xl flex items-center">
                  {location}
                  <button onClick={() => removeLocation(location)} className="text-red-500 ml-1 ">✕</button>
                </span>
              ))}
              <input
                type="text"
                placeholder="Search locations"
                className="bg-transparent flex-1 outline-none"
                value={locationSearch}
                onChange={(e) => setLocationSearch(e.target.value)}
              />
            </div>
            <div className="bg-white border rounded max-h-32 overflow-y-auto">
              {filteredLocations.map((location, index) => (
                <div key={index} className="flex items-center px-4 py-2">
                  <input
                    type="checkbox"
                    checked={selectedLocations.includes(location)}
                    onChange={() => handleLocationSelect(location)}
                    className="mr-2"
                  />
                  <label>{location}</label>
                </div>
              ))}
            </div>
          </div>

        {/* Apply Filter Button */}
        <button className="w-full bg- [#C06C3D] text-white py-2 rounded bg-[#FF9630]">
          Apply Filter
        </button>
      </div>
    </div>
    </div>
    </>
  );
};

export default Filter;
